<template>
  <LabelEditor :application="true"></LabelEditor>
</template>
<script>
import LabelEditor from './LabelEditor'

export default {
  name: 'LabelApplication',
  data: function () {
    return {}
  },
  components: {
    LabelEditor
  }
}
</script>
<style lang='scss' scoped>
</style>



// WEBPACK FOOTER //
// src/components/LabelApplication.vue